export default __webpack_public_path__ + "static/media/kilnhelper_feature_graphic.bdabf219.png";